import { Link, useParams } from 'react-router';
import { Button } from '~/common/components/ui/button';
import { ShoppingCart, Mail } from 'lucide-react';
import { CartTotalPrice } from '~/features/cart/components/CartTotalPrice';
import { CircularProgress } from '~/common/components/CircularProgress';
import { cn } from '~/common/utils/styleUtil';
import { useCartIsBusy } from '../../features/cart/state-hooks/useCartIsBusy';
import { useCartSummary } from '../../features/cart/state-hooks/useCartSummary';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export function CartButton() {
  const { lang, area } = useParams();
  const { total, isOciOrder, positionCount, externalPositionCount } = useCartSummary();
  const { cartIsProcessingPosition, cartIsCancelling, cartIsRefreshing } = useCartIsBusy();
  const variant =
    (positionCount && positionCount > 0) || (externalPositionCount && externalPositionCount > 0) ? 'default' : 'ghost';

  const isProcessing = cartIsProcessingPosition || cartIsCancelling || cartIsRefreshing;

  return (
    <TrackNavigationClick label={'Warenkorb'}>
      <Button asChild={true} variant={variant} data-testid={'header-cart-button'}>
        <Link to={`/${lang}/${area}/cart`}>
          {!isProcessing && isOciOrder && <Mail size={24} />}
          {!isProcessing && !isOciOrder && (
            <ShoppingCart size={24} className={cn('mr-2', variant === 'ghost' ? 'text-secondary' : 'text-white')} />
          )}
          {isProcessing && <CircularProgress size={'md'} className="mr-2" />}
          {!!total && total > 0 && <CartTotalPrice price={total ?? 0} showCurrency={false} size={'sm'} />}
        </Link>
      </Button>
    </TrackNavigationClick>
  );
}
